export default __webpack_public_path__ + "static/biggest-shopping-malls-d7073b3c1fb1acda3971ec4503ffcaa7.jpg";